import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { cn } from '../../lib/utils';

interface BrandLogoProps {
  reversed?: boolean;
  showWordmark?: boolean;
  wordmarkVariant?: 'app' | 'editorial';
  className?: string;
  linkTo?: string | null;
}

export function BrandLogo({
  reversed = false,
  showWordmark = true,
  wordmarkVariant = 'app',
  className,
  linkTo = '/',
}: BrandLogoProps): React.JSX.Element {
  const { t } = useTranslation('common');

  const content = (
    <div className={cn('flex items-center gap-2.5', className)}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 32 32"
        fill="none"
        aria-hidden={showWordmark ? true : undefined}
        aria-label={showWordmark ? undefined : t('brand.name')}
        role={showWordmark ? undefined : 'img'}
        className="h-8 w-8 shrink-0 rounded-[2px] text-[var(--ir-terra)]"
      >
        <rect x="2" y="2" width="28" height="28" rx="2" fill="currentColor" />
        <path
          d="M9.5 20.5L14 16l3 3 5.5-5.5"
          stroke="#ffffff"
          strokeWidth="2.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18 13.5h4.5V18"
          stroke="#ffffff"
          strokeWidth="2.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
      {showWordmark ? (
        wordmarkVariant === 'editorial' ? (
          <span
            className={cn(
              'font-serif text-2xl font-bold leading-none tracking-tight',
              reversed ? 'text-white' : 'text-[var(--ir-ink)]'
            )}
          >
            Inmueble
            <span className="italic text-[var(--ir-terra)]">.red</span>
          </span>
        ) : (
          <span
            className={cn(
              'frontpage-type-brand truncate',
              reversed ? 'text-white' : 'text-brand-primary'
            )}
          >
            {t('brand.name')}
          </span>
        )
      ) : null}
    </div>
  );

  if (linkTo) {
    return (
      <Link to={linkTo} className="inline-flex min-h-11 shrink-0 items-center">
        {content}
      </Link>
    );
  }

  return content;
}
